import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Logo from '../SmartEvacLogo.jpg';
import NewLogo from '../NewSmartEvacLogo.png';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useNavigate } from 'react-router-dom';
import {app, auth} from './Firebase.js';
import { signInWithEmailAndPassword  } from "firebase/auth";
import React, { useState } from 'react';

function Login() {
  const navigate = useNavigate(); 
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [colour, setColour] = useState("white");
  const [attemptNumber, setattemptNumber] = useState(4);
  
  

  const handleRegister = (event) => {
    event.preventDefault();
    navigate('/register'); 
  };
  const handleReturn = (event) => {
    event.preventDefault();
    navigate('/');
  };


  return (
    <Container className= "main-page-content">
      <Row className="justify-content-center">
        <Col xs={6} sm={6} md={6} lg={6}>
          <h2>Too many failed attempts</h2>
          <p className="SignUpIndicator">
            <span className="SignUpQuestion">New to SmartEvac?</span>
            <a href="#" onClick={handleRegister}>Join now</a>
          </p>
          <p className="SignUpIndicator">
            <span className="SignUpQuestion">Return to</span>
            <a href="#" onClick={handleReturn}>Login</a>
          </p>
        </Col>
      </Row>
    </Container>
  );
}

export default Login;
